import { useContext, useEffect, useState } from "react";
import {
    Bar,
    BarChart,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis, YAxis
} from 'recharts';
import Swal from "sweetalert2";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Footer from "../Footer";
import { useDashboard } from "../Header/DashboardContext";
import Header from "../Header/Header";
import Sidebar1 from "../Sidebar1";

import { FaCalculator, FaListAlt, FaSearch } from "react-icons/fa";
import { HiOutlineDownload } from "react-icons/hi";
import { MdDashboard, MdSupportAgent } from "react-icons/md";
import { TbMapPinCode, TbTruckDelivery } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import { refeshPend } from "../../App";
import { getApi, postApi } from "../../components/Admin Master/Area Control/Zonemaster/ServicesApi";
import './dashboard.css';

// Colors for Pie slices






function Dashboard() {
    const show = JSON.parse(localStorage.getItem("Login"));

    const [isOpenTrack, setISOpenTrack] = useState(false);
    const [isOpenPin, setISOpenPin] = useState(false);
    const [docketNo, setDocketNo] = useState("");
    const { docket, setDocket,pin,setPin } = useContext(refeshPend);
    const [pincode, setPincode] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const login = JSON.parse(localStorage.getItem("Login"));
    const colors = ["#000", "#000", "#000", "#000", "#000", "#000"];
    
  
    const scanCard = [
        login?.GooglePayScanner1,
        login?.GooglePayScanner2,
        login?.GooglePayScanner2
    ]
    
    const data1 = [
        {
            name: 'Jan',
            uv: 200,
            pv: 2500,
            amt: 4100,
        },
        {
            name: 'Feb',
            uv: 1000,
            pv: 3398,
            amt: 2210,
        },
        {
            name: 'March',
            uv: 2000,
            pv: 5800,
            amt: 2290,
        },
        {
            name: 'April',
            uv: 780,
            pv: 5908,
            amt: 2000,
        },
        {
            name: 'May',
            uv: 890,
            pv: 3800,
            amt: 2181,
        },
        {
            name: 'June',
            uv: 2390,
            pv: 1800,
            amt: 2500,
        },
        {
            name: 'July',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];

    const data2 = [
        { name: "Group A", value: 400 },
        { name: "Group B", value: 300 },
        { name: "Group C", value: 300 },
        { name: "Group D", value: 200 }
    ];  

    const cards = [
        {
            name: "Create Shipment",
            color: "green-card",
            logo: <TbTruckDelivery size={35} />,
            action: () => navigate("/dailybooking")
        },
        {
            name: "Track Shipment",
            color: "blue-card",
            logo: <FaSearch size={35} />,
            action: () => setISOpenTrack(true)
        },
        {
            name: "Track PinCode",
            color: "red-card",
            logo: <TbMapPinCode size={35} />,
            action: () => setISOpenPin(true)
        },
        {
            name: "Rate Calculator",
            color: "orange-card",
            logo: <FaCalculator size={35} />,
            action: () => navigate("/dailybooking", { state: { tab: "rate" } })
        },
        {
            name: "All Shipments",
            color: "purple-card",
            logo: <FaListAlt size={35} />,
            action: () => navigate("/statusreport", { state: { tab: "mis" } })
        },
        {
            name: "Bulk Upload",
            color: "sky-card",
            logo: <HiOutlineDownload size={35} />,
            action: () => navigate("/dailybooking", { state: { tab: "excelimport" } })
        },
        {
            name: "Support Ticket",
            color: "pink-card",
            logo: <MdSupportAgent size={35} />,
            action: () => console.log("Support Open")
        }
    ];
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletAmount, setWalletAmount] = useState(0);

    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setTooltipPosition({ x: e.clientX, y: e.clientY });
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const { dashboardData } = useDashboard();
    console.log(dashboardData);

    const bk = dashboardData?.booking[0] || {};
    const mf = dashboardData?.manifest || {};
    const ins = dashboardData?.inscon || {};
    const rs = dashboardData?.runsheet || {};
    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
    const COLORS1 = ["#FFA500", "#000000"];
    const COLORS2 = ["#007BFF", "red"];


    const [dCount,setDcount]=useState({});
    const [vCount,setVcount]=useState([]);
    const [vGraph,setVgraph]=useState([]);
    const [dGraph,setDgraph]=useState([]);

    const courierData = vCount.map((item) => ({
  name: item.Vendor_Name,
  value: item.TotalBooking,
  remaining: Math.max(0, 100 - item.TotalBooking) // safe
}));



    console.log(cards);


    const fecthDcount = async () => {

        try {
            const response = await getApi(`/Master/DashboardCount?Location_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`);
            if (response.Success === 1) {
                setDcount(response.Data)
            } else {
                 setDcount({});
            }
        } catch (error) {
            console.error(error);
            setDcount({});
        }
    };

    const fecthVCount = async () => {

        try {
            const response = await getApi(`/Master/DashboardVendorCount?Location_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`);
            if (response.Success === 1) {
                setVcount(response.Data)
            } else {
                 setVcount([]);
            }
        } catch (error) {
            console.error(error);
            setVcount([]);
        }
    };

    const fecthVgraph = async () => {

        try {
            const response = await getApi(`Master/DashboardMonthlyVendorBooking?Location_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`);
            if (response.Success === 1) {
                setVgraph(response.Data)
            } else {
                 setVgraph([]);
            }
        } catch (error) {
            console.error(error);
            setVgraph([]);
        }
    };

   const fecthDgraph = async () => {
    try {
        const response = await getApi(
            `Master/DashboardMonthlyBooking?Location_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`
        );

        if (response.Success === 1) {
            const apiData = response.Data || [];

            // Create full 12 months structure
            const monthsTemplate = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ].map((name, index) => ({
                MonthNo: index + 1,
                MonthName: name,
                TotalBooking: 0
            }));

            // Merge API data into template
            const mergedData = monthsTemplate.map((m) => {
                const found = apiData.find(
                    (d) => d.MonthNo === m.MonthNo
                );

                return found
                    ? { ...m, TotalBooking: found.TotalBooking }
                    : m;
            });

            setDgraph(mergedData);
        } else {
            setDgraph([]);
        }
    } catch (error) {
        console.error(error);
        setDgraph([]);
    }
};


const dataMax = dGraph?.length
  ? Math.max(...dGraph.map(item => item.TotalBooking))
  : 0;

  const dataMax2 = vCount?.length
  ? Math.max(...vCount.map(item => item.TotalBooking))
  : 0;


    const getWalletLedger = async (CustomerCode) => {
        if (!CustomerCode) return;

        try {
            const response = await postApi(`/Master/getWalletLedgerDocketWise?Customer_Code=${CustomerCode}`);
            if (response.status === 1) {
                setWalletBalance(response.Summary.CurrentBalance);
                setWalletAmount(response.Summary.TotalDebit);
            } else {
                setWalletBalance(0);
                setWalletAmount(0);
            }
        } catch (error) {
            console.error(error);
            setWalletBalance(0);
            setWalletAmount(0);
        }
    };
    useEffect(() => {
        getWalletLedger(JSON.parse(localStorage.getItem('Login'))?.Customer_Code);
        fecthDcount();
        fecthVCount();
        fecthVgraph();
        fecthDgraph();
    }, []);


    const handleTrack = () => {
        if (!docketNo.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter Docket Number!",
                customClass: {
                    popup: "swal-above-modal"
                }
            });
            return;
        }

        setDocket(docketNo)

        setISOpenTrack(false);
        setDocketNo("");
    };

    const handleTrackPin = () => {
        if (!pincode) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter Pincode!",
                customClass: {
                    popup: "swal-above-modal"
                }
            });
            return;
        }

        // Add pincode logic here
        setPin(pincode)
        setISOpenPin(false);
        setPincode("");
    };

    return (
        <>
            <Header />
            <Sidebar1 />

            <div id="main-body">
                {show?.DashboardAccess===0
                ?
                     <div
        style={{
          background: "white",
          minHeight: "100vh",
        }}
      >
      </div>
                :
                <div className="dashboard-container">
                    <div className="top-div">
                        <div className="top-right">
                            <span className="top-icon">
                                <MdDashboard />
                            </span>

                            <span className="top-text">
                                Booking Analytics Dashboard
                            </span>
                        </div>
                        {JSON.parse(localStorage.getItem("Login"))?.Customer_Code && <div className="top-left">

                            <span>
                                BALANCE :
                            </span>
                            <span style={{ color: "red" }}>
                                {`₹ ${walletBalance || 0}`}
                            </span>
                        </div>}
                    </div>


                    <div className="cards-grid">
                        {cards.map((card, index) => (
                            <div key={index} className={`dashboard-card ${card.color}`} onClick={card.action}>
                                <div className='icon-circle'>
                                    {card.logo}
                                </div>

                                <h3>{card.name}</h3>
                            </div>
                        ))}
                    </div>
                    {/* MIDDLE SECTION */}
                    <div className="middle-section">




                        <div className="right-box">
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>{dCount?.TotalBooking}</h3>
                                        <p>Booking</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>{dCount?.Delivered}</h3>
                                        <p>Delivered</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>{dCount?.RTO}</h3>
                                        <p>RTO</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>{dCount?.InTransit}</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>{dCount?.Inscan}</h3>
                                        <p>In Sacn</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>{dCount?.OutForDelivery}</h3>
                                        <p>Out For D</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>0</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>{dCount?.CashBooking}</h3>
                                        <p>Cash</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>{dCount?.CreditBooking}</h3>
                                        <p>Credit</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>{dCount?.ToPayBooking}</h3>
                                        <p>To Pay</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>0</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>0</h3>
                                        <p>Cancelled</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>0</h3>
                                        <p>Failed</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>0</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                        </div>




                        {/* STATISTIC */}
                        <div className="stat-card">
                            <div className="stat-header">
                                <b>Statistic</b>

                                <div className="dropdown">
                                    <button onClick={toggleDropdown} className="dropdown-btn">
                                        Select Option ▼
                                    </button>

                                    {isOpen && (
                                        <ul className="dropdown-menu">
                                            <li>This Month</li>
                                            <li>This Week</li>
                                            <li>Today</li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <ResponsiveContainer width="100%" height="90%">
                                <LineChart
                                    data={dGraph}
                                    margin={{
                                        top: 5,
                                        right: 10,
                                        left: -20,
                                        bottom: 5
                                    }}
                                >
                                    <XAxis
                                        dataKey="MonthName"
                                        tick={{ fontSize: 12 }}
                                    />

                                    <YAxis domain={[0, dataMax => dataMax + 5]} tick={{ fontSize: 12 }}
                                        width={40}/>
                                    

                                    <Tooltip />

                                    

                                 
                  
                   
                    <Line
                        type="monotone"
                        dataKey="TotalBooking"
                        stroke="purple"
                        strokeWidth={2}
                        dot={{ r: 4 }}
                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                    </div>

                    <div className="middle-section">




                        <div className="right-box">
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                         <div className="sub-div">
                <span className="title">
                    Courier
                </span>
                <span className="sub-text">
                    Top 5 Couriers
                </span>
            </div>
                                    </div>
                                </div>

                                <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
  <BarChart
    layout="vertical"
    data={courierData}
    margin={{
      top: 20,
      right: 10,
      left: 0, // increase more
      bottom: 0
    }}
    barCategoryGap={18}
  >

    <YAxis
  dataKey="name"
  type="category"
  width={100}
  tickLine={false}
  axisLine={false}
  
  tick={({ x, y, payload }) => {
    const wrapText = (text, limit = 2) => {
  const words = text.split(" ");
  const lines = [];

  for (let i = 0; i < words.length; i += limit) {
    lines.push(words.slice(i, i + limit).join(" "));
  }

  return lines;
};
  const lines = wrapText(payload.value);

  return (
    <text x={x - 10} y={y} textAnchor="end" fontSize={12} fill="#666">
      {lines.map((line, i) => (
        <tspan x={x - 10} dy={i === 0 ? 0 : 14} key={i}>
          {line}
        </tspan>
      ))}
    </text>
  );
}}
/>

    <XAxis
      type="number"
      
      ticks={[0,20,40,60,80,100]}
      tickFormatter={(v)=>`${v}`}
      axisLine={false}
      tickLine={false}
    />

   
    {/* Black value bar */}
    <Bar
      dataKey="value"
      stackId="a"
      fill="#000"
      radius={[0,0,0,0]}
      barSize={25}
    />


    {/* Gray background */}
    <Bar
      dataKey="remaining"
      stackId="a"
       fill="#efefef"
       radius={[0, 8, 8, 0]}
      barSize={25}
    />

    

  </BarChart>
</ResponsiveContainer>
    </div>

                            </div>
                            <div className="box-card">

                                <div className="card-header">
                                    <div className="title-wrap">
                                        <span className="icon-box">
                                            <TbTruckDelivery />
                                        </span>

                                        <span className="title">
                                            Delivery Status
                                        </span>
                                    </div>
                                </div>

                                <div className="status-grid">

                                    <div className="status-box blue">
                                        <h3>219</h3>
                                        <p>Total</p>
                                    </div>

                                    <div className="status-box green">
                                        <h3>132</h3>
                                        <p>Delivered</p>
                                    </div>

                                    <div className="status-box orange">
                                        <h3>36</h3>
                                        <p>Created</p>
                                    </div>

                                    <div className="status-box purple">
                                        <h3>31</h3>
                                        <p>In Transit</p>
                                    </div>

                                    <div className="status-box red">
                                        <h3>11</h3>
                                        <p>Cancelled</p>
                                    </div>

                                    <div className="status-box pink">
                                        <h3>0</h3>
                                        <p>Failed</p>
                                    </div>

                                    <div className="status-box violet">
                                        <h3>15</h3>
                                        <p>Picked Up</p>
                                    </div>

                                    <div className="status-box gray">
                                        <h3>0</h3>
                                        <p>Un-delivered</p>
                                    </div>

                                </div>

                            </div>
                        </div>




                        {/* STATISTIC */}
                        <div className="stat-card">
                            <div className="stat-header">
                                <b>Statistic</b>

                                <div className="dropdown">
                                    <button onClick={toggleDropdown} className="dropdown-btn">
                                        Select Option ▼
                                    </button>

                                    {isOpen && (
                                        <ul className="dropdown-menu">
                                            <li>This Month</li>
                                            <li>This Week</li>
                                            <li>Today</li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <ResponsiveContainer width="100%" height="90%">
                                <LineChart
                                    data={data1}
                                    margin={{
                                        top: 5,
                                        right: 10,
                                        left: -20,
                                        bottom: 5
                                    }}
                                >
                                    <XAxis
                                        dataKey="name"
                                        tick={{ fontSize: 12 }}
                                    />

                                    <YAxis
                                        tick={{ fontSize: 12 }}
                                        width={25}
                                    />

                                    <Tooltip />

                                    <Line
                                        type="monotone"
                                        dataKey="pv"
                                        stroke="purple"
                                        strokeWidth={2}
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#0088FE"
                                        strokeWidth={2}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                    </div>


                    <div className="scan-card-wrapper">
                        {scanCard.map((item, index) => (
                            <div className="scan-card" key={index}>
                                <img src={item} alt={`scan-${index}`} />
                            </div>
                        ))}
                    </div>

                    {
                        isOpenTrack && (

                            <div className="modal-overlay">

                                <div className="track-modal">

                                    <div className="modal-header">

                                        <div>

                                            <h3>Track Shipment</h3>
                                            <p>Enter your docket number</p>

                                        </div>

                                        <button
                                            className="close-btn"
                                            onClick={() => setISOpenTrack(false)}
                                        >
                                            ✕
                                        </button>

                                    </div>

                                    <div className="modal-body">

                                        <input
                                            type="text"
                                            placeholder="Enter Docket No"
                                            value={docketNo}
                                            onChange={(e) => setDocketNo(e.target.value)}
                                        />

                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="cancel-btn"
                                            onClick={() => setISOpenTrack(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="submit-btn"
                                            onClick={handleTrack}
                                        >
                                            Track Now
                                        </button>

                                    </div>

                                </div>

                            </div>

                        )
                    }

                    {
                        isOpenPin && (

                            <div className="modal-overlay">

                                <div className="track-modal">

                                    <div className="modal-header">

                                     <div>

                                            <h3>Track Pin Code</h3>
                                            <p>Enter Pin Code</p>

                                        </div>

                                        <button
                                            className="close-btn"
                                            onClick={() => setISOpenPin(false)}
                                        >
                                            ✕
                                        </button>

                                    </div>

                                    <div className="modal-body">

                                        <input
                                            type="tel"
                                            placeholder="Enter Pin Code"
                                            maxLength={6}
                                            value={pincode}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                setPincode(value);
                                            }}
                                        />

                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="cancel-btn"
                                            onClick={() => setISOpenPin(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="submit-btn"
                                            onClick={handleTrackPin}
                                        >
                                            Track Now
                                        </button>

                                    </div>

                                </div>

                            </div>

                        )
                    }


                </div>}
                <Footer />
                
            </div>
        </>
    )
}


export default Dashboard;